import { useMutation } from '@tanstack/react-query';

import { addFavouriteTask, removeFavouriteTask } from 'api/favourites.service';
import { useToast } from 'hooks/ui';
import { useFavoritesStore } from 'store/favorites';

type ToggleVars = { taskId: string; favorite: boolean };

export const useFavouriteTaskToggle = () => {
  const toast = useToast();
  const setTaskFavorite = useFavoritesStore((s) => s.setTaskFavorite);

  const { mutate, isPending } = useMutation({
    mutationFn: async ({ taskId, favorite }: ToggleVars) => {
      if (favorite) {
        await addFavouriteTask(taskId);
      } else {
        await removeFavouriteTask(taskId);
      }
    },
    onMutate: async ({ taskId, favorite }) => {
      const wasFavorite = useFavoritesStore.getState().isTaskFavorite(taskId);

      setTaskFavorite(taskId, favorite);

      return { wasFavorite };
    },
    onError: (_err, { taskId }, context) => {
      const revert = context?.wasFavorite ?? false;

      setTaskFavorite(taskId, revert);
      toast.error('Could not update favourite. Please try again.');
    },
  });

  return { mutate, isPending };
};
